import React, { useCallback, useState } from 'react';
import s from './ImageWizardBlock.module.css';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { wizardImageUrl } from '../../../../shared/api/imageProjectApi';
import { selectLoading, selectSelectedImage } from '../../../../store/selectors/imageSelectors';
import Slider from '../../../../shared/ui/slider/Slider';
import Button from '../../../../shared/ui/button/Button';
import IconStars from '../../../../shared/ui/icons/IconStars';
import {
    selectIsBasicSubscription,
    selectIsFreeSubscription,
} from '../../../../store/selectors/subscriptionSelector';
import IconLock from '../../../../shared/ui/icons/IconLock';
import { setPricingModal } from '../../../../store/slices/pageSlice';

const ImageWizardBlock: React.FC = () => {
    const selectedImage = useSelector(selectSelectedImage);
    const isLoading = useSelector(selectLoading);
    const dispatch = useAppDispatch();

    const [prompt, setPrompt] = useState('');
    const [creativity, setCreativity] = useState(1);

    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const isBasicSubscription = useSelector(selectIsBasicSubscription);

    const isRestrictPrompt = isFreeSubscription || isBasicSubscription;

    const HandleGenerate = useCallback(async () => {
        if (isRestrictPrompt) {
            dispatch(setPricingModal(true));
            return;
        }
        if (!selectedImage?.image?.id) return;
        await dispatch(
            wizardImageUrl({
                imageId: selectedImage.image.id,
                input: prompt,
                creativity,
            }),
        );
        setPrompt('');
    }, [selectedImage?.image?.id, prompt, creativity, dispatch]);

    return (
        <div className={s.container}>
            <p className={s.title}>Image Wizard</p>
            <p className={s.subtitle}>
                Time for the magic — our AI will handle the image editing for you!
            </p>

            <textarea
                readOnly={isLoading}
                className={s.textarea}
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder="Add a prompt to add or change elements inside the image..."
            />

            <div className={s.sliderWrapper}>
                <label htmlFor="creativity" className={s.sliderLabel}>
                    Adjust AI creativity level
                </label>
                <div className={s.sliderRow}>
                    <Slider
                        min={0}
                        max={2}
                        step={1}
                        value={creativity}
                        onChange={setCreativity}
                        label="word"
                    />
                </div>
            </div>

            <div className={s.buttonWrapper}>
                <Button
                    text={isLoading ? 'Generating…' : 'Generate'}
                    onClick={HandleGenerate}
                    state={
                        isLoading || !selectedImage?.image?.id || !prompt.trim()
                            ? 'disabled'
                            : 'enabled'
                    }
                    style={{
                        backgroundColor: '#FFDD35',
                        color: '#000',
                        fontWeight: '600',
                        width: '100%',
                        height: '40px',
                    }}
                    icon={isRestrictPrompt ? <IconLock color="black" /> : <IconStars />}
                    iconPosition="left"
                />
            </div>

            <p className={s.subtext}>
                Some ideas: e.g., "Replace background with a city skyline", "Add lens flare", or
                "Switch car to a convertible".
            </p>
        </div>
    );
};

export default ImageWizardBlock;
